import {ChangeDetectionStrategy, Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {AuthService} from "../_services/auth.service";
import {MatDrawerMode, MatSidenavModule} from "@angular/material/sidenav";
import {MatDialog} from "@angular/material/dialog";
import {ContentService} from "../_services/content.service";
import {GreetingPipe} from "../_pipes/greeting.pipe";
import {NotificationsService} from "../_services/notifications.service";
import {User} from "../_types/user";
import {NotificationSidebarComponent} from "../shared/notification-sidebar/notification-sidebar.component";
import {MatIconModule} from "@angular/material/icon";
import {RouterModule} from "@angular/router";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatListModule} from "@angular/material/list";
import {MatButtonModule} from "@angular/material/button";
import {MatBadgeModule} from "@angular/material/badge";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {NameDisplayPipe} from "../_pipes/name-display.pipe";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatMenuModule} from "@angular/material/menu";
import {AlertBannerComponent} from "../shared/alert-banner/alert-banner.component";
import {FooterComponent} from "../shared/footer/footer.component";
import {MatTooltipModule} from "@angular/material/tooltip";
import {NgOptimizedImage} from "@angular/common";
import {SnackbarService} from "../_services/snackbar.service";

@Component({
    selector: 'app-authview',
    templateUrl: './authview.component.html',
    styleUrls: ['./authview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NotificationSidebarComponent, MatSidenavModule,
        MatIconModule, RouterModule, MatExpansionModule, MatListModule,
        MatButtonModule, MatBadgeModule, MatProgressSpinnerModule,
        NameDisplayPipe, MatToolbarModule, GreetingPipe, MatMenuModule,
        AlertBannerComponent, FooterComponent, MatTooltipModule, NgOptimizedImage]
})

export class AuthviewComponent implements OnInit, OnDestroy {
    user!: User;
    isMobile: boolean = false;
    mode: MatDrawerMode = 'over';
    sideNav: boolean = false;
    notificationNavOpened: boolean = false;
    hijacking: boolean = false;
    isRaa: boolean = false;
    hasContactEmail: boolean = false;
    notificationsCount: string | null = null;
    timelineId: number | undefined;
    interval: ReturnType<typeof setTimeout> | undefined;
    protected readonly GreetingPipe: typeof GreetingPipe = GreetingPipe;
    private readonly raaTrainingCentreRoles: string[] = ['Adoptive Family', 'Birth Family'];

    constructor(private authService: AuthService,
                public dialog: MatDialog,
                public contentService: ContentService,
                private notificationService: NotificationsService,
                private snackbarService: SnackbarService) {
        this.authService.getUser().subscribe({
            next: r => {
                this.user = r;
            }
        })
        this.authService.getDynamicSettings().then((r): void => {
            this.isRaa = r.is_raa;
            this.hasContactEmail = !!r.contact_email;
        });
        if (localStorage.getItem('hijacked')) {
            this.hijacking = true;
        }
        this.getNotificationCount();
        if (this.user?.role?.role_type == 'young_person') {
            // if child then hide timeline if no timelines present
            this.contentService.viewMyTimeline().subscribe({
                next: r => {
                    this.timelineId = r.id
                }, error: error => {
                    console.error(error)
                }
            });
        }

        let that: this = this;
        this.interval = setInterval(function (): void {
            // Check user every minute to ensure the user hasn't timed out or been forcibly timed out by an admin
            if (that.authService.isLoggedIn()) {
                that.authService.userHeartbeat().subscribe({
                    next: r => {
                    }, error: error => {
                        console.error(error)
                    }
                });
            }
        }, 60000);
    }

    get showTrainingCentre(): boolean {
        return !!this.user && (!this.isRaa || this.raaTrainingCentreRoles.includes(this.user.role.name));
    }

    get canBookTrainingSession(): boolean {
        return this.showTrainingCentre
            && this.user.role.role_type !== 'young_person'
            && !(this.isRaa && this.user.role.name === 'Birth Family');
    }

    getNotificationCount(): void {
        this.notificationService.getNotificationsCount().subscribe({
            next: r => {
                if (r.count > 99) {
                    this.notificationsCount = '99+';
                } else {
                    this.notificationsCount = JSON.stringify(r.count);
                }
            }, error: error => {
                console.error(error)
            }
        });
    }

    ngOnDestroy(): void {
        clearTimeout(this.interval);
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: UIEvent): void {
        this.isMobile = window.innerWidth <= 600;
        if (!this.isMobile) {
            this.sideNav = false;
        }
    }

    ngOnInit(): void {
        this.isMobile = window.innerWidth <= 600;
    }

    logout(): void {
        this.authService.logout();
    }

    openNotificationNav(): void {
        this.sideNav = false;
        this.notificationNavOpened = true;
    }

    openHelp(trainingModal: boolean = false): void {
        import('../shared/help/help.component')
            .then(({HelpComponent}): void => {
                this.dialog.open(HelpComponent, {
                    panelClass: 'mediumWindow',
                    data: {bookingModal: trainingModal}
                });
            })
            .catch((error: unknown): void => {
                console.error('Dialog failed to load', error);
                this.snackbarService.openSnackBar('A new version of Virtual Memory Box is available. Refreshing now so you can retry.', 'error');
                setTimeout((): void => window.location.reload(), 1500);
            });
    }

}
